import { ADD_TO_URL_SELECTS, addToUrlSelectValue } from "#/admin/legacy/forms/add-to-url.js";

jQuery(function () {
  var selectSelector = ADD_TO_URL_SELECTS;
  var inputSelector = 'textarea[data-sparkle-action~="add-to-url"]';

  // BEHAVIOUR
  jQuery(document).on("change", selectSelector, function () {
    addSelectedValueToUrl(this);
  });

  jQuery(document).on("change", inputSelector, function () {
    addInputValueToUrl(this);
  });

  function addSelectedValueToUrl(el) {
    var value = addToUrlSelectValue(el);
    var selectedElement = jQuery(el);

    addToUrl(selectedElement, value);
  }

  function addInputValueToUrl(el) {
    var value = jQuery(el).val();
    var selectedElement = jQuery(el);

    addToUrl(selectedElement, value);
  }

  function addToUrl(selectedElement, value) {
    var target = selectedElement.attr("data-url-target");
    var paramName = selectedElement.attr("data-url-param");
    var currentURL = jQuery(target).attr("href");
    var newURL = new URL(currentURL);
    newURL.searchParams.set(paramName, value);
    jQuery(target).attr("href", newURL.href.toString());
  }
});
